// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__1jjw3","header":"Messages_header__sWULs"};